import { setFile } from './file'
import { subscribeToChannel } from './pusher'
import { createStandardAction } from 'typesafe-actions'
import { ThunkResult } from './types'

export const ActionTypes = {
  DOCUMENT_DELETE_REQUEST: 'DOCUMENT_DELETE_REQUEST',
  DOCUMENT_DELETE_SUCCESS: 'DOCUMENT_DELETE_SUCCESS',
  SET_DOCUMENT_UPLOAD_START_TIME: 'SET_DOCUMENT_UPLOAD_START_TIME',
}

export const documentDeleteRequest = createStandardAction(ActionTypes.DOCUMENT_DELETE_REQUEST)()
export const documentDeleteSuccess = createStandardAction(ActionTypes.DOCUMENT_DELETE_SUCCESS)()
export const setDocUploadStartTime = createStandardAction(ActionTypes.SET_DOCUMENT_UPLOAD_START_TIME)()

export const createDocumentGdrive = (): ThunkResult<void> => (dispatch, getState, { gapi }) => {
  gapi
    .openDocumentPicker()
    .then((data: any) => Promise.resolve(data.docs[0]))
    .then((gdriveDocument: any) => {
      gapi.downloadDocx(gdriveDocument.id).then((documentData: any) => {
        dispatch(setFile(documentData.file))
        dispatch(subscribeToChannel())
      })
    })
}
